import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { AccordionModule } from '../accordion/accordion.module';
import { AlertModule } from '../alert/alert.module';
import { CheckBoxModule } from '../checkbox/checkbox.module';
import { InputSelectModule } from '../input-select/input-select.module';
import { FareFamiliesComponent } from './fare-families.component';
import { FareFamilyComponent } from './fare-family/fare-family.component';
import { ComparisonPerFlightComponent } from './comparison-per-flight/comparison-per-flight.component';
import { SpinnerModule } from '../spinner/spinner.module';
import { PipesModule } from 'src/app/core/pipes/pipes.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    AccordionModule,
    CheckBoxModule,
    InputSelectModule,
    AlertModule,
    SpinnerModule,
    PipesModule
  ],
  declarations: [FareFamiliesComponent, FareFamilyComponent, ComparisonPerFlightComponent],
  exports: [FareFamiliesComponent, ComparisonPerFlightComponent]
})
export class FareFamiliesModule {}
